import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// components

import CardStatsForAdmin from "components/Cards/CardStatsForAdmin";

export default function HeaderStatsForAdmin() {


    const [ totalusers , setTotalUses] = useState([]);

    useEffect(() => {
        const fetchExpenseTypes = async () => {
            try {
                const response = await fetch(
                    `${BASE_URL}/api/Expense/GetUserCount`
                );
                const data = await response.json();

                console.log(data);  
                setTotalUses(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchExpenseTypes();
    }, []);

    return (
        <>
            {/* Header */}
            <div className="relative md:pt-8 pb-16 ">
                <div className=" mx-auto w-full">
                    <div>
                        {/* Card stats */}
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStatsForAdmin
                                    statSubtitle="Total Users"
                                    statTitle={totalusers.totalUsers}
                                    statPercentColor="text-emerald-500"
                                    statIconName="fa fa-users"
                                    statIconColor="bg-red-500"
                                />
                            </div>
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStatsForAdmin
                                    statSubtitle="Active Users"
                                    statTitle={totalusers.activeUsers}
                                    statPercentColor="text-orange-500"
                                    statIconName="fa fa-users"
                                    statIconColor="bg-orange-500"
                                />
                            </div>
                            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                                <CardStatsForAdmin
                                    statSubtitle="UnVerified Users"
                                    statTitle={totalusers.unverifyedUsers}
                                    statPercentColor="text-red-500"
                                    statIconName="fa fa-users"
                                    statIconColor="bg-pink-500"
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
